export const ALL_DASHBOARD_REQUEST = "ALL_DASHBOARD_REQUEST"
export const ALL_DASHBOARD_SUCCESS = "ALL_DASHBOARD_SUCCESS"
export const ALL_DASHBOARD_FAIL = "ALL_DASHBOARD_FAIL"

export const ALL_TOP_DASHBOARD_REQUEST = "ALL_TOP_DASHBOARD_REQUEST"
export const ALL_TOP_DASHBOARD_SUCCESS = "ALL_TOP_DASHBOARD_SUCCESS"
export const ALL_TOP_DASHBOARD_FAIL = "ALL_TOP_DASHBOARD_FAIL"

export const ALL_ACTIVE_DASHBOARD_USER_REQUEST = "ALL_ACTIVE_DASHBOARD_USER_REQUEST"
export const ALL_ACTIVE_TOP_DASHBOARD_USER_SUCCESS = "ALL_ACTIVE_TOP_DASHBOARD_USER_SUCCESS"
export const ALL_ACTIVE_TOP_DASHBOARD_USER_FAIL = "ALL_ACTIVE_TOP_DASHBOARD_USER_FAIL"

export const ALL_SALESDATAFORDASHBOARD_REQUEST = "ALL_SALESDATAFORDASHBOARD_REQUEST"
export const ALL_SALESDATAFORDASHBOARD_SUCCESS = "ALL_SALESDATAFORDASHBOARD_SUCCESS"
export const ALL_SALESDATAFORDASHBOARD_FAIL = "ALL_SALESDATAFORDASHBOARD_FAIL"

export const ALL_SALESDATAFORDASHBOARD_WITHUSER_REQUEST = "ALL_SALESDATAFORDASHBOARD_WITHUSER_REQUEST"
export const ALL_SALESDATAFORDASHBOARD_WITHUSER_SUCCESS = "ALL_SALESDATAFORDASHBOARD_WITHUSER_SUCCESS"
export const ALL_SALESDATAFORDASHBOARD_WITHUSER_FAIL = "ALL_SALESDATAFORDASHBOARD_WITHUSER_FAIL"

export const ALL_PURCHASEDATAFORDASHBOARD_REQUEST = "ALL_PURCHASEDATAFORDASHBOARD_REQUEST"
export const ALL_PURCHASEDATAFORDASHBOARD_SUCCESS = "ALL_PURCHASEDATAFORDASHBOARD_SUCCESS"
export const ALL_PURCHASEDATAFORDASHBOARD_FAIL = "ALL_PURCHASEDATAFORDASHBOARD_FAIL"

export const ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_REQUEST = "ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_REQUEST"
export const ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_SUCCESS = "ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_SUCCESS"
export const ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_FAIL = "ALL_PURCHASEDATAFORDASHBOARD_FORSHOP_FAIL"

export const ALL_EXPENSEDATA_REQUEST = "ALL_EXPENSEDATA_REQUEST"
export const ALL_EXPENSEDATA_SUCCESS = "ALL_EXPENSEDATA_SUCCESS"
export const ALL_EXPENSEDATA_FAIL = "ALL_EXPENSEDATA_FAIL"

export const ALL_EXPENSEDATA_FORSHOP_REQUEST = "ALL_EXPENSEDATA_FORSHOP_REQUEST"
export const ALL_EXPENSEDATA_FORSHOP_SUCCESS = "ALL_EXPENSEDATA_FORSHOP_SUCCESS"
export const ALL_EXPENSEDATA_FORSHOP_FAIL = "ALL_EXPENSEDATA_FORSHOP_FAIL"


export const CLEAR_ERRORS = "CLEAR_ERRORS"